export const INTEREST_TAGS = [
    "🧳 국내 여행",
    "✈️ 해외 여행",
    "❄️ 겨울 스포츠",
    "⛰️ 등산",
    "🎥 영화/드라마",
    "⛺️ 캠핑",
    "🤿 프리다이빙",
    "🐳 수상 스포츠",
    "🖼️ 전시회",
    "🥨 요리/베이킹",
    "☕️ 커피/차",
    "🎲 보드게임",
    "📚 독서",
];

export const PERSONALITY_TAGS = [
    // 나이
    "2030",
    "3040",

    // 도전·열정
    "도전적인",
    "열정적인",
    "추진력있는",
    "끈기있는",

    // 협동·팀워크
    "배려심있는",
    "사교적인",
    "활발한",
    "책임감있는",

    // 감각·집중
    "차분한",
    "세심한",
    "창의적인",

    // 긍정·밝음
    "긍정적인",
    "진취적인",
    "밝은",
];
